import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import { SURFACE_BRAND_LIGHT, TEXT_PRIMARY, BORDER_BRAND, TEXT_BRAND } from '@CSSVars/colors'

import { BREAK_POINT_LG } from '@CSSVars/variables'

export const _Card = styled.div`
  background-color: ${SURFACE_BRAND_LIGHT};
  border-radius: 10px;
  padding: 24px;
  width: 100%;
  text-align: center;
  margin: 43px 0;
  display: flex;
  flex-direction: row;
  gap: 53px;
   @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    gap: 16px;
  }
`

export const _TextContainer = styled.div`
 display: flex;
 flex-direction: column;

`

export const _IconWrapper = styled.div`
display: flex;
justify-content: start;
svg {
  path {
    fill: ${TEXT_BRAND};
  }
}
`

export const _Heading = styled.div`
color: ${TEXT_PRIMARY};
text-align: left;
font-family: Montserrat;
font-size: 14px;
font-weight: 600;
line-height: 20px;
span {
font-size: 14px;
line-height: 20px;
font-weight: 700;
}
`

export const _Text = styled.p`
margin: 12px 0;
color: ${TEXT_PRIMARY};
font-family: Montserrat;
font-size: 12px;
font-weight: 500;
line-height: 20px; 
text-align: left;
`

export const _BtnContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
      @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
}
`

export const _PrimaryButton = styled(AppButton)`
  padding: 11px 16px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  height: 44px;
`

export const _SecondaryButton = styled(AppButton)`
  padding: 11px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  height: 44px;
  border: 1px solid ${BORDER_BRAND};
  color: ${TEXT_BRAND};
`
